import { createContext, useContext, type ReactNode } from "react";
import { useFocusMode } from "@/hooks/useFocusMode";

type FocusContextType = ReturnType<typeof useFocusMode>;

const FocusContext = createContext<FocusContextType | undefined>(undefined);

export function FocusProvider({ children }: { children: ReactNode }) {
  const focus = useFocusMode();
  return <FocusContext.Provider value={focus}>{children}</FocusContext.Provider>;
}

export function useFocus() {
  const ctx = useContext(FocusContext);
  if (!ctx) throw new Error("useFocus must be inside FocusProvider");
  return ctx;
}
